/**
 * Derives up-to-two-character initials from a display name.
 *
 * - Two or more words → first letter of each of the first two words ("Bruno Valenzuela" → "BV").
 * - Single word → first two characters ("Chris" → "CH", "Richard" → "RI").
 * - Single character → that character ("R" → "R").
 * - Empty or missing → "?".
 *
 * The single-word "first two characters" fallback exists because one-letter initials
 * (e.g. just "C") read as placeholder-ish in avatar circles; two letters give enough
 * signal without needing a surname.
 */
export function getInitials(name: string | undefined): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) {
    const word = parts[0]!;
    return word.slice(0, 2).toUpperCase();
  }
  return ((parts[0]![0] ?? "") + (parts[1]![0] ?? "")).toUpperCase();
}
